export class DataLayerData {
  event: string;
  pagina: DataLayerPaginaData;
}

export class DataLayerPaginaData {
  nomePagina: string;
  templatePagina: string;
  contratos?: DataLayerContratosData;
}

export class DataLayerContratosData {
  statusGeral?: SituacaoContratoDataLayer;
  numeroContrato?: string;
  mercadoria?: string;
  dataVencimento?: string;
  saldo?: number;
  parcelasPagas?: number;
  situacao?: SituacaoContratoDataLayer;
}

export enum SituacaoContratoDataLayer {
  EM_ATRASO = 'em atraso',
  EM_ABERTO = 'em aberto',
  PAGO = 'pago',
}
